angular
  .module('contrast.settings.expired.password', [])
  .controller(
    'ExpiredPasswordCtrl',
    function (
      $scope,
      $location,
      permissions,
      logger,
      ProfileFactory,
      ErrorService,
      UserService,
      logoutService
    ) {
      'ngInject'

      angular.extend($scope, {
        profile: {
          currentpassword: '',
          newpassword: '',
          confirmpassword: '',
          passwordvalid: false
        }
      })

      angular.extend($scope, {
        save: save,
        cancel: cancel
      })

      function save() {
        ProfileFactory.updateExpiredPassword(
          $scope.profile.newpassword,
          $scope.profile.currentpassword
        ).then(function (response) {
          logger.logSuccess(response.data.messages[0])
          permissions.loadUserSettings(true).then(function () {
            $location.path(UserService.buildUrl('/dashboard'), true)
          })
        }, ErrorService.processError)
      }

      function cancel() {
        logoutService.logout({ redirectToSignin: true })
      }
    }
  )
